import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { apiGetProcesses } from "../../../api/ApiProcess";
import { apiRecupEspacesGrantedColidee } from "../../../api/ApiColidee";
import { Image } from "react-bootstrap";
import ComponentTitle from "../../layout/ComponentTitle";
import { apiGetOrgunits } from "../../../api/ApiOrgunit";
import { Link } from "react-router-dom";
import illusRituels from "../../../assets/images/illusRituels.jpg";
import ComponentLoader from "../../layout/ComponentLoader";
import { toDateTimeFR } from "../../../utils/datesHeures";
import { BiMessageDetail } from "react-icons/bi";
import ComponentTitleAndSousTitle from "../../layout/ComponentTitleAndSousTitle";

const BlocEpingle1 = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxToken } = useSelector((state) => state.ReduxToken);
  const [espaces, setEspaces] = useState([]);
  const [focusPrimaire, setFocusPrimaire] = useState();
  const [focusSecondaire, setFocusSecondaire] = useState([]);
  const [loader, setLoader] = useState(false);

  const recupDatas = async () => {
    const resRituels = await apiGetOrgunits(
      ReduxInstance._id
      //"filter[type]=Rituel&filter[type]=Partie prenante&filter[type]=Temps collectif"
    );
    if (resRituels.data) {
      let focusPrimaireSearch = "";
      let focusSecondaireSearch = [];
      resRituels.data.forEach((rituel, index) => {
        if (rituel.focusPrimaire && rituel.enSommeil !== true) {
          focusPrimaireSearch = rituel;
        }
        if (rituel.focusSecondaire && rituel.enSommeil !== true) {
          focusSecondaireSearch.push(rituel);
        }
      });
      setFocusPrimaire(focusPrimaireSearch);
      setFocusSecondaire(focusSecondaireSearch);
    }

    // récupération Espaces Colidée
    var espacesSouhaites = [];
    const resProcesses = await apiGetProcesses(
      ReduxInstance._id,
      "filter[famille]=MacroProcess&sort=-ordre"
    );
    resProcesses.data.map(
      (process) => (espacesSouhaites = espacesSouhaites.concat(process.espaces))
    );
    espacesSouhaites = espacesSouhaites.filter((x, i, a) => a.indexOf(x) === i);
    const form = new FormData();
    form.append("espacesSouhaites", espacesSouhaites.join(","));
    const resEspaces = await apiRecupEspacesGrantedColidee(ReduxToken, form);

    if (resEspaces.data) {
      resEspaces.data.sort((b, a) =>
        a.dateDerniereContrib > b.dateDerniereContrib
          ? 1
          : b.dateDerniereContrib > a.dateDerniereContrib
          ? -1
          : 0
      );
      setEspaces(resEspaces.data);
    }
    setLoader(false);
  };

  const backgroundRituel = (rituel) => {
    if (rituel.cardPic) {
      return (
        `url(` + process.env.REACT_APP_URL_EXPRESS + "images/orgunit/small/" + rituel.cardPic + `)`
      );
    } else {
      return ReduxInstance.rituelPic
        ? `url(` +
            process.env.REACT_APP_URL_EXPRESS +
            "images/instance/small/" +
            ReduxInstance.rituelPic +
            `)`
        : `url(` + illusRituels + `)`;
    }
  };

  useEffect(() => {
    if (ReduxInstance.modulesActives.includes("accueil1")) {
      setLoader(true);
      recupDatas();
    }
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="hackHomeEthicsTransparent">
      {ReduxInstance.modulesActives.includes("accueil1") && (
        <>
          <ComponentTitleAndSousTitle
            className="flex-grow-1"
            title={t("public.pageHome.titleBloc1")}
          />
          {loader && <ComponentLoader />}
        </>
      )}
      <br />
      {(espaces.length > 0 || focusPrimaire !== "" || focusSecondaire.length > 0) &&
        ReduxInstance.modulesActives.includes("accueil1") && (
          <>
            <div className="containerBlocEpingle">
              {focusPrimaire && (
                <Link to={"/orgunits/" + focusPrimaire._id} className="d-flex flex-nowrap mb-3">
                  <div
                    className="blocIllustration"
                    style={{
                      backgroundImage: backgroundRituel(focusPrimaire),
                    }}
                  ></div>
                  <div className="gouvernance flex-grow-1">
                    <div className="categorieArticles">
                      {focusPrimaire.type === "Rituel" && t("public.pageHome.categorieObjet2")}
                      {focusPrimaire.type === "Temps collectif" &&
                        t("public.pageHome.categorieObjet3")}
                      {focusPrimaire.type === "Partie prenante" &&
                        t("public.pageHome.categorieObjet4")}
                      {focusPrimaire.type === "Rôle" && t("public.pageHome.categorieObjet5")}
                      {focusPrimaire.type === "Mission" && t("public.pageHome.categorieObjet13")}
                    </div>
                    {focusPrimaire.nom}
                  </div>
                </Link>
              )}

              {!focusPrimaire &&
                espaces.slice(0, 1).map((espace, index) => (
                  <a
                    href={
                      process.env.REACT_APP_URL_COLIDEE +
                      "o" +
                      espace.id_entreprise +
                      "p" +
                      espace.id_plateforme
                    }
                    target="_blank"
                    rel="noreferrer"
                    key={"secondaire" + index}
                    className="d-flex flex-nowrap mb-3"
                  >
                    <div
                      className="blocIllustration"
                      style={{
                        backgroundImage: `url(` + espace.picture.replace("_small", "") + `)`,
                      }}
                    ></div>
                    <div className="gouvernance flex-grow-1">
                      <div className="categorieArticles">
                        {t("public.pageHome.categorieObjet1")} <br />
                        <BiMessageDetail size="1.5em" /> {espace.NbrContributions}
                        <span className="float-end">
                          {toDateTimeFR(espace.dateDerniereContrib)}
                        </span>
                      </div>{" "}
                      {espace.nom}
                    </div>
                  </a>
                ))}

              <div className="blocSecondaire d-flex justify-content-between  ">
                {focusSecondaire.map((item, index) => (
                  <Link
                    to={"/orgunits/" + item._id}
                    className="d-flex flex-nowrap    mb-3"
                    key={"secondaire" + index}
                  >
                    <div
                      className="blocIllustration"
                      style={{
                        backgroundImage: backgroundRituel(item),
                      }}
                    ></div>

                    <div className="gouvernance flex-grow-1">
                      <div className=" categorieArticles">
                        {item.type === "Mission" && t("public.pageHome.categorieObjet13")}
                        {item.type === "Rituel" && t("public.pageHome.categorieObjet2")}
                        {item.type === "Temps collectif" && t("public.pageHome.categorieObjet3")}
                        {item.type === "Partie prenante" && t("public.pageHome.categorieObjet4")}
                        {item.type === "Rôle" && t("public.pageHome.categorieObjet5")}
                      </div>{" "}
                      {item.nom}
                    </div>
                  </Link>
                ))}

                {espaces
                  .slice(
                    focusPrimaire ? 0 : 1,
                    focusPrimaire ? 2 - focusSecondaire.length : 3 - focusSecondaire.length
                  )
                  .map((espace, index) => (
                    <a
                      href={
                        process.env.REACT_APP_URL_COLIDEE +
                        "o" +
                        espace.id_entreprise +
                        "p" +
                        espace.id_plateforme
                      }
                      target="_blank"
                      rel="noreferrer"
                      key={"secondaire" + index}
                      className="d-flex flex-nowrap mb-3"
                    >
                      <div
                        className="blocIllustration"
                        style={{
                          backgroundImage: `url(` + espace.picture.replace("_small", "") + `)`,
                        }}
                      ></div>
                      <div className="gouvernance flex-grow-1">
                        <div className="categorieArticles">
                          {t("public.pageHome.categorieObjet1")} <br />
                          <BiMessageDetail size="1.5em" /> {espace.NbrContributions}
                          <span className="float-end">
                            {toDateTimeFR(espace.dateDerniereContrib)}
                          </span>
                        </div>{" "}
                        {espace.nom}
                      </div>
                    </a>
                  ))}
              </div>
            </div>
          </>
        )}
    </div>
  );
};

export default BlocEpingle1;
